import { WebMercatorViewport } from '@deck.gl/core/typed';
import {ICON_MAPPING} from "@components/Maps/ScatterMap/lib/icon-mapping";

export const getBoundingBox = (
  center: [number, number],
  zoom: number,
  width: number,
  height: number,
): {
  rng_longitude: [number, number],
  rng_latitude: [number, number],
} => {
  const viewport = new WebMercatorViewport({
    longitude: center[0],
    latitude: center[1],
    zoom: zoom,
    width: width,
    height: height
  });

  const topLeft = viewport.unproject([0, 0]); // (minLng, maxLat)
  const bottomRight = viewport.unproject([width, height]); // (maxLng, minLat)

  return {
    rng_longitude: [topLeft[0], bottomRight[0]],
    rng_latitude: [bottomRight[1], topLeft[1]],
  };
}

export const getPinPropertiesKey = (count: number) => {
  const mappingKeys = Object.keys(ICON_MAPPING)
    .map((k) => parseInt(k.replace("marker-", "")))
    .sort((a, b) => b - a);
  for (const key of mappingKeys) {
    if (count < key)
      continue;
    return `marker-${key}`;
  }
  return `marker-1`;
}